// Generated by purs version 0.15.16
import * as App_Route from "../App.Route/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as GraphQL_Type from "../GraphQL.Type/index.js";
import * as Steps_Step3_FillQueue from "../Steps.Step3.FillQueue/index.js";
import * as Steps_Step3_Transition from "../Steps.Step3.Transition/index.js";
import * as Steps_Step3_Types from "../Steps.Step3.Types/index.js";
import * as Steps_WorkQueue_Cache from "../Steps.WorkQueue.Cache/index.js";
import * as Widgets_Comments from "../Widgets.Comments/index.js";
import * as Widgets_Form from "../Widgets.Form/index.js";
import * as Widgets_Signature_Group from "../Widgets.Signature.Group/index.js";
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var eqRNTY = /* #__PURE__ */ GraphQL_Type.eqRNTY(Data_Eq.eqString);
var eq = /* #__PURE__ */ Data_Eq.eq(eqRNTY);
var map1 = /* #__PURE__ */ Data_Functor.map(Effect_Aff.functorAff);
var map2 = /* #__PURE__ */ Data_Functor.map(Data_Either.functorEither);
var bind = /* #__PURE__ */ Control_Bind.bind(Data_Either.bindEither);
var pure = /* #__PURE__ */ Control_Applicative.pure(Data_Either.applicativeEither);
var notEq = /* #__PURE__ */ Data_Eq.notEq(eqRNTY);
var SaveThenCancel = /* #__PURE__ */ (function () {
    function SaveThenCancel() {

    };
    SaveThenCancel.value = new SaveThenCancel();
    return SaveThenCancel;
})();
var SaveThenFinish = /* #__PURE__ */ (function () {
    function SaveThenFinish() {

    };
    SaveThenFinish.value = new SaveThenFinish();
    return SaveThenFinish;
})();
var SaveThenExport = /* #__PURE__ */ (function () {
    function SaveThenExport(value0) {
        this.value0 = value0;
    };
    SaveThenExport.create = function (value0) {
        return new SaveThenExport(value0);
    };
    return SaveThenExport;
})();
var SaveThenLock = /* #__PURE__ */ (function () {
    function SaveThenLock() {

    };
    SaveThenLock.value = new SaveThenLock();
    return SaveThenLock;
})();
var upsertBy = function (dictEq) {
    var eq1 = Data_Eq.eq(dictEq);
    return function (key) {
        return function (updates) {
            return function (existing) {
                return append(updates)(Data_Array.filter(function (current) {
                    return !Data_Array.any(function ($$new) {
                        return eq1(key($$new))(key(current));
                    })(updates);
                })(existing));
            };
        };
    };
};
var upsertBy1 = /* #__PURE__ */ upsertBy(eqRNTY);
var updateSignatures = function (updateGroup) {
    return function (updateDoc) {
        return function (fillState) {
            return {
                form: fillState.form,
                comments: fillState.comments,
                attachments: fillState.attachments,
                preview: fillState.preview,
                signatures: updateGroup(fillState.signatures),
                doc: updateDoc(fillState.doc)
            };
        };
    };
};
var updateComments = function (updateList) {
    return function (nextPost) {
        return function (fillState) {
            var comments = updateList(fillState.comments.comments);
            return {
                form: fillState.form,
                attachments: fillState.attachments,
                preview: fillState.preview,
                signatures: fillState.signatures,
                comments: {
                    id: fillState.comments.id,
                    formId: fillState.comments.formId,
                    can: fillState.comments.can,
                    comments: comments,
                    post: nextPost(fillState.comments)
                },
                doc: {
                    id: fillState.doc.id,
                    student: fillState.doc.student,
                    semester: fillState.doc.semester,
                    teacher: fillState.doc.teacher,
                    signatures: fillState.doc.signatures,
                    verifications: fillState.doc.verifications,
                    updated_at: fillState.doc.updated_at,
                    created_at: fillState.doc.created_at,
                    locked_at: fillState.doc.locked_at,
                    exports: fillState.doc.exports,
                    access: fillState.doc.access,
                    employer: fillState.doc.employer,
                    position: fillState.doc.position,
                    contact: fillState.doc.contact,
                    courses: fillState.doc.courses,
                    attachments: fillState.doc.attachments,
                    can: fillState.doc.can,
                    formId: fillState.doc.formId,
                    formName: fillState.doc.formName,
                    mutations: fillState.doc.mutations,
                    signature_fields: fillState.doc.signature_fields,
                    json: fillState.doc.json,
                    comments: comments
                }
            };
        };
    };
};
var updateAttachments = function (updateList) {
    return function (fillState) {
        var attachments = updateList(fillState.attachments.attachments);
        return {
            form: fillState.form,
            comments: fillState.comments,
            preview: fillState.preview,
            signatures: fillState.signatures,
            attachments: {
                id: fillState.attachments.id,
                formId: fillState.attachments.formId,
                description: fillState.attachments.description,
                attachments: attachments
            },
            doc: {
                id: fillState.doc.id,
                student: fillState.doc.student,
                semester: fillState.doc.semester,
                teacher: fillState.doc.teacher,
                signatures: fillState.doc.signatures,
                verifications: fillState.doc.verifications,
                updated_at: fillState.doc.updated_at,
                created_at: fillState.doc.created_at,
                locked_at: fillState.doc.locked_at,
                exports: fillState.doc.exports,
                access: fillState.doc.access,
                employer: fillState.doc.employer,
                position: fillState.doc.position,
                contact: fillState.doc.contact,
                courses: fillState.doc.courses,
                can: fillState.doc.can,
                formId: fillState.doc.formId,
                formName: fillState.doc.formName,
                mutations: fillState.doc.mutations,
                comments: fillState.doc.comments,
                signature_fields: fillState.doc.signature_fields,
                json: fillState.doc.json,
                attachments: attachments
            }
        };
    };
};
var shouldSaveCurrentDocument = function ($67) {
    return Steps_Step3_FillQueue.shouldSaveDocument((function (v) {
        return v.editor;
    })($67));
};
var setPendingLoadTarget = function (target) {
    return function (state) {
        return {
            saveOperationId: state.saveOperationId,
            loadOperationId: state.loadOperationId,
            autofillOperationId: state.autofillOperationId,
            lockOperationId: state.lockOperationId,
            documentMutationOperationId: state.documentMutationOperationId,
            pendingPostSave: state.pendingPostSave,
            editor: {
                queue: state.editor.queue,
                transitionState: state.editor.transitionState,
                workQueueState: state.editor.workQueueState,
                workQueueUi: state.editor.workQueueUi,
                workQueueCache: state.editor.workQueueCache,
                fillState: state.editor.fillState,
                position: target.position,
                anchor: target.anchor,
                activeSection: target.anchor,
                sectionIntent: Data_Maybe.maybe(App_Route.SectionClear.value)(App_Route.SectionSet.create)(target.anchor)
            }
        };
    };
};
var setEditorState = function (editor) {
    return function (state) {
        return {
            saveOperationId: state.saveOperationId,
            loadOperationId: state.loadOperationId,
            autofillOperationId: state.autofillOperationId,
            lockOperationId: state.lockOperationId,
            documentMutationOperationId: state.documentMutationOperationId,
            pendingPostSave: state.pendingPostSave,
            editor: editor
        };
    };
};
var saveCurrentDocument = function ($68) {
    return Steps_Step3_FillQueue.saveDocument((function (v) {
        return v.editor;
    })($68));
};
var replaceComment = function (comment) {
    return map(function (current) {
        var $55 = eq(current.id)(comment.id);
        if ($55) {
            return comment;
        };
        return current;
    });
};
var preloadStep3Resources = function (workQueueState) {
    return function (workQueueCache) {
        return function (maybeFormType) {
            return function (maybeDoc) {
                return Control_Monad_Except_Trans.runExceptT(Steps_WorkQueue_Cache.preloadStep3Resources(workQueueState)(workQueueCache)(maybeFormType)(maybeDoc));
            };
        };
    };
};
var mapEditorState = function (fn) {
    return function (state) {
        return {
            saveOperationId: state.saveOperationId,
            loadOperationId: state.loadOperationId,
            autofillOperationId: state.autofillOperationId,
            lockOperationId: state.lockOperationId,
            documentMutationOperationId: state.documentMutationOperationId,
            pendingPostSave: state.pendingPostSave,
            editor: fn(state.editor)
        };
    };
};
var loadOperationKindForState = function ($69) {
    return Steps_Step3_Types.loadOperationKindForState((function (v) {
        return v.editor;
    })($69));
};
var isBusy = function (state) {
    return Data_Maybe.isJust(state.saveOperationId) || (Data_Maybe.isJust(state.loadOperationId) || (Data_Maybe.isJust(state.autofillOperationId) || (Data_Maybe.isJust(state.lockOperationId) || Data_Maybe.isJust(state.documentMutationOperationId))));
};
var initialLoadOperationKind = Steps_Step3_Types.initialLoadOperationKind;
var hasEditableFields = function ($70) {
    return Steps_Step3_Types.hasEditableFields((function (v) {
        return v.editor.fillState;
    })($70));
};
var fromEditorState = function (editor) {
    return {
        editor: editor,
        saveOperationId: Data_Maybe.Nothing.value,
        loadOperationId: Data_Maybe.Nothing.value,
        autofillOperationId: Data_Maybe.Nothing.value,
        lockOperationId: Data_Maybe.Nothing.value,
        documentMutationOperationId: Data_Maybe.Nothing.value,
        pendingPostSave: Data_Maybe.Nothing.value
    };
};
var loadInitialStep3State = function (workQueueState) {
    return function (workQueueUi) {
        return function (workQueueCache) {
            return function (doc) {
                return function (initialAnchor) {
                    return map1(map2(fromEditorState))(Steps_Step3_FillQueue.loadInitFillQueue(workQueueState)(workQueueUi)(workQueueCache)(doc)(Steps_Step3_Transition.emptyTransitionState)(initialAnchor));
                };
            };
        };
    };
};
var defaultRenderOptions = Steps_Step3_Types.defaultRenderOptions;
var applySignatureRefresh = function (refresh) {
    return function (fillState) {
        return {
            comments: fillState.comments,
            attachments: fillState.attachments,
            preview: fillState.preview,
            signatures: Widgets_Signature_Group.loadSignatures(refresh)(Widgets_Signature_Group.refreshFieldPermissions(refresh.signature_fields)(fillState.signatures)),
            form: {
                id: fillState.form.id,
                label: fillState.form.label,
                fields: fillState.form.fields,
                access: refresh.access
            },
            doc: {
                id: fillState.doc.id,
                student: fillState.doc.student,
                semester: fillState.doc.semester,
                teacher: fillState.doc.teacher,
                updated_at: fillState.doc.updated_at,
                created_at: fillState.doc.created_at,
                exports: fillState.doc.exports,
                employer: fillState.doc.employer,
                position: fillState.doc.position,
                contact: fillState.doc.contact,
                courses: fillState.doc.courses,
                attachments: fillState.doc.attachments,
                formId: fillState.doc.formId,
                formName: fillState.doc.formName,
                mutations: fillState.doc.mutations,
                comments: fillState.doc.comments,
                json: fillState.doc.json,
                signatures: refresh.signatures,
                verifications: refresh.verifications,
                signature_fields: refresh.signature_fields,
                locked_at: refresh.locked_at,
                access: refresh.access,
                can: {
                    comment: fillState.doc.can.comment,
                    private_comment: fillState.doc.can.private_comment,
                    attach: fillState.doc.can.attach,
                    "delete": fillState["doc"]["can"]["delete"],
                    copy: fillState.doc.can.copy,
                    create_employers: fillState.doc.can.create_employers,
                    lock: refresh.can.lock,
                    update: refresh.can.update
                }
            }
        };
    };
};
var applySavedDocumentState = function (state) {
    return function (doc) {
        return map2(function (editor) {
            return {
                autofillOperationId: state.autofillOperationId,
                documentMutationOperationId: state.documentMutationOperationId,
                loadOperationId: state.loadOperationId,
                lockOperationId: state.lockOperationId,
                pendingPostSave: state.pendingPostSave,
                editor: editor,
                saveOperationId: Data_Maybe.Nothing.value
            };
        })(Steps_Step3_FillQueue.applySavedDocument(state.editor)(doc));
    };
};
var applyLoadedEditorState = function (waitState) {
    return function (loadedState) {
        return {
            saveOperationId: waitState.saveOperationId,
            autofillOperationId: waitState.autofillOperationId,
            lockOperationId: waitState.lockOperationId,
            documentMutationOperationId: waitState.documentMutationOperationId,
            pendingPostSave: waitState.pendingPostSave,
            editor: Steps_Step3_FillQueue.mergeTransitionWaitState(waitState.editor)(loadedState),
            loadOperationId: Data_Maybe.Nothing.value
        };
    };
};
var loadTargetStep3State = function (current) {
    return function (doc) {
        return map1(map2(applyLoadedEditorState(current)))(Steps_Step3_FillQueue.loadFillState(current.editor)(doc));
    };
};
var applyFillStateUpdate = function (fn) {
    return function (state) {
        var fillState = fn(state.editor.fillState);
        return {
            saveOperationId: state.saveOperationId,
            loadOperationId: state.loadOperationId,
            autofillOperationId: state.autofillOperationId,
            lockOperationId: state.lockOperationId,
            documentMutationOperationId: state.documentMutationOperationId,
            pendingPostSave: state.pendingPostSave,
            editor: {
                queue: state.editor.queue,
                position: state.editor.position,
                anchor: state.editor.anchor,
                activeSection: state.editor.activeSection,
                sectionIntent: state.editor.sectionIntent,
                transitionState: state.editor.transitionState,
                workQueueUi: state.editor.workQueueUi,
                workQueueCache: state.editor.workQueueCache,
                fillState: fillState,
                workQueueState: Steps_WorkQueue_Cache.insertDocument(fillState.doc)(state.editor.workQueueState)
            }
        };
    };
};
var applyToggleLockResult = function (state) {
    return function (result) {
        return applyFillStateUpdate(applySignatureRefresh(result))({
            saveOperationId: state.saveOperationId,
            loadOperationId: state.loadOperationId,
            autofillOperationId: state.autofillOperationId,
            documentMutationOperationId: state.documentMutationOperationId,
            pendingPostSave: state.pendingPostSave,
            editor: Steps_Step3_Types.toggleLock(result)(state.editor),
            lockOperationId: Data_Maybe.Nothing.value
        });
    };
};
var applyAutofillResult = function (state) {
    return function (res) {
        var formCtx = (function () {
            var v = Steps_Step3_Types.formContext(state.editor.workQueueCache)(state.editor.fillState);
            return {
                access: v.access,
                account: v.account,
                autofillArgs: v.autofillArgs,
                curIndex: v.curIndex,
                doc: v.doc,
                parentIds: v.parentIds,
                isAutofilling: true
            };
        })();
        var newDoc = {
            access: state.editor.fillState.doc.access,
            attachments: state.editor.fillState.doc.attachments,
            can: state.editor.fillState.doc.can,
            comments: state.editor.fillState.doc.comments,
            contact: state.editor.fillState.doc.contact,
            courses: state.editor.fillState.doc.courses,
            created_at: state.editor.fillState.doc.created_at,
            exports: state.editor.fillState.doc.exports,
            formId: state.editor.fillState.doc.formId,
            formName: state.editor.fillState.doc.formName,
            id: state.editor.fillState.doc.id,
            json: state.editor.fillState.doc.json,
            locked_at: state.editor.fillState.doc.locked_at,
            mutations: state.editor.fillState.doc.mutations,
            position: state.editor.fillState.doc.position,
            semester: state.editor.fillState.doc.semester,
            signature_fields: state.editor.fillState.doc.signature_fields,
            signatures: state.editor.fillState.doc.signatures,
            student: state.editor.fillState.doc.student,
            teacher: state.editor.fillState.doc.teacher,
            updated_at: state.editor.fillState.doc.updated_at,
            verifications: state.editor.fillState.doc.verifications,
            employer: res.employer
        };
        return bind(Widgets_Form.setFormData(formCtx)(res.data)(state.editor.fillState.form))(function (newFormState) {
            return pure({
                documentMutationOperationId: state.documentMutationOperationId,
                loadOperationId: state.loadOperationId,
                lockOperationId: state.lockOperationId,
                pendingPostSave: state.pendingPostSave,
                saveOperationId: state.saveOperationId,
                editor: {
                    activeSection: state.editor.activeSection,
                    anchor: state.editor.anchor,
                    position: state.editor.position,
                    queue: state.editor.queue,
                    sectionIntent: state.editor.sectionIntent,
                    transitionState: state.editor.transitionState,
                    workQueueCache: state.editor.workQueueCache,
                    workQueueState: state.editor.workQueueState,
                    workQueueUi: state.editor.workQueueUi,
                    fillState: {
                        attachments: state.editor.fillState.attachments,
                        comments: state.editor.fillState.comments,
                        preview: state.editor.fillState.preview,
                        form: newFormState,
                        doc: newDoc,
                        signatures: Widgets_Signature_Group.updateDefSignatures(state.editor.fillState.signatures)(res.signature_fields)
                    }
                },
                autofillOperationId: Data_Maybe.Nothing.value
            });
        });
    };
};
var appendComment = function (comment) {
    return function (comments) {
        return append(comments)([ comment ]);
    };
};
var applyResult = /* #__PURE__ */ (function () {
    var keepCommentState = function (state) {
        return state.post;
    };
    return function (v) {
        if (v instanceof Steps_Step3_Types.CommentCreated) {
            return updateComments(appendComment(v.value0))(function (v1) {
                return new Widgets_Comments.Posting({
                    text: "",
                    "public": v["value0"]["public"]
                });
            });
        };
        if (v instanceof Steps_Step3_Types.CommentUpdated) {
            return updateComments(replaceComment(v.value0))(function (v1) {
                return new Widgets_Comments.Posting({
                    text: "",
                    "public": v["value0"]["public"]
                });
            });
        };
        if (v instanceof Steps_Step3_Types.CommentDeleted) {
            return updateComments(Data_Array.filter(function (comment) {
                return notEq(comment.id)(v.value0);
            }))(keepCommentState);
        };
        if (v instanceof Steps_Step3_Types.AttachmentCreated) {
            return updateAttachments(function (v1) {
                return append(v1)([ v.value0 ]);
            });
        };
        if (v instanceof Steps_Step3_Types.AttachmentDeleted) {
            return updateAttachments(Data_Array.filter(function (attachment) {
                return attachment.id !== v.value0;
            }));
        };
        if (v instanceof Steps_Step3_Types.SignatureSigned) {
            return updateSignatures(Widgets_Signature_Group.loadSignatures({
                signatures: [ v.value0 ],
                verifications: [  ],
                signature_fields: [  ]
            }))(function (doc) {
                return {
                    id: doc.id,
                    student: doc.student,
                    semester: doc.semester,
                    teacher: doc.teacher,
                    verifications: doc.verifications,
                    updated_at: doc.updated_at,
                    created_at: doc.created_at,
                    locked_at: doc.locked_at,
                    exports: doc.exports,
                    access: doc.access,
                    employer: doc.employer,
                    position: doc.position,
                    contact: doc.contact,
                    courses: doc.courses,
                    attachments: doc.attachments,
                    can: doc.can,
                    formId: doc.formId,
                    formName: doc.formName,
                    mutations: doc.mutations,
                    comments: doc.comments,
                    signature_fields: doc.signature_fields,
                    json: doc.json,
                    signatures: upsertBy1(function (v2) {
                        return v2.key;
                    })([ v.value0 ])(doc.signatures)
                };
            });
        };
        if (v instanceof Steps_Step3_Types.SignatureSignedAndRefreshed) {
            var $71 = updateSignatures(Widgets_Signature_Group.loadSignatures({
                signatures: [ v.value0 ],
                verifications: [  ],
                signature_fields: [  ]
            }))(function (doc) {
                return {
                    id: doc.id,
                    student: doc.student,
                    semester: doc.semester,
                    teacher: doc.teacher,
                    verifications: doc.verifications,
                    updated_at: doc.updated_at,
                    created_at: doc.created_at,
                    locked_at: doc.locked_at,
                    exports: doc.exports,
                    access: doc.access,
                    employer: doc.employer,
                    position: doc.position,
                    contact: doc.contact,
                    courses: doc.courses,
                    attachments: doc.attachments,
                    can: doc.can,
                    formId: doc.formId,
                    formName: doc.formName,
                    mutations: doc.mutations,
                    comments: doc.comments,
                    signature_fields: doc.signature_fields,
                    json: doc.json,
                    signatures: upsertBy1(function (v2) {
                        return v2.key;
                    })([ v.value0 ])(doc.signatures)
                };
            });
            var $72 = applySignatureRefresh(v.value1);
            return function ($73) {
                return $71($72($73));
            };
        };
        if (v instanceof Steps_Step3_Types.SignatureGroupRefreshed) {
            return applySignatureRefresh(v.value0);
        };
        if (v instanceof Steps_Step3_Types.SignaturesRequested) {
            return updateSignatures(Widgets_Signature_Group.loadVerifications(v.value0))(function (doc) {
                return {
                    id: doc.id,
                    student: doc.student,
                    semester: doc.semester,
                    teacher: doc.teacher,
                    signatures: doc.signatures,
                    updated_at: doc.updated_at,
                    created_at: doc.created_at,
                    locked_at: doc.locked_at,
                    exports: doc.exports,
                    access: doc.access,
                    employer: doc.employer,
                    position: doc.position,
                    contact: doc.contact,
                    courses: doc.courses,
                    attachments: doc.attachments,
                    can: doc.can,
                    formId: doc.formId,
                    formName: doc.formName,
                    mutations: doc.mutations,
                    comments: doc.comments,
                    signature_fields: doc.signature_fields,
                    json: doc.json,
                    verifications: upsertBy1(function (v2) {
                        return v2.data.key;
                    })(v.value0)(doc.verifications)
                };
            });
        };
        throw new Error("Failed pattern match at Steps.Step3.State (line 193, column 15 - line 226, column 100): " + [ v.constructor.name ]);
    };
})();
var applyDocumentMutationResult = function (state) {
    return function (result) {
        return pure(applyFillStateUpdate(applyResult(result))(state));
    };
};
export {
    SaveThenCancel,
    SaveThenFinish,
    SaveThenExport,
    SaveThenLock,
    defaultRenderOptions,
    fromEditorState,
    mapEditorState,
    setEditorState,
    preloadStep3Resources,
    loadInitialStep3State,
    loadTargetStep3State,
    setPendingLoadTarget,
    isBusy,
    saveCurrentDocument,
    shouldSaveCurrentDocument,
    hasEditableFields,
    applySavedDocumentState,
    applyLoadedEditorState,
    applyAutofillResult,
    applyToggleLockResult,
    applyDocumentMutationResult,
    initialLoadOperationKind,
    loadOperationKindForState
};
//# sourceMappingURL=index.js.map
